// extracted by mini-css-extract-plugin
export default {"card":"TX-z","carouselContainer":"UX-z","carouselContent":"VX-z"};